module.exports = __webpack_public_path__ + "assets/speeding_road.979d90fb.svg";